import { render, staticRenderFns } from "./PassingRate.vue?vue&type=template&id=06f32db2&scoped=true"
import script from "./PassingRate.vue?vue&type=script&lang=js"
export * from "./PassingRate.vue?vue&type=script&lang=js"
import style0 from "./PassingRate.vue?vue&type=style&index=0&id=06f32db2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f32db2",
  null
  
)

export default component.exports